<template>
    <el-dialog :title="titleDialog" :visible="showDialog" @close="close" @open="create">
        <form autocomplete="off" @submit.prevent="submit">
            <div class="form-body">
                <div class="row">
                    <div class="col-md-12" v-if="configuration.enable_anulation_password">
                        <div class="form-group" :class="{'has-danger': errors[`documents.0.voided_code`]}">
                            <label class="control-label">Código de seguridad
                                <el-tooltip class="item" content="Obligatorio si el administrador lo ha establecido" effect="dark" placement="top-start">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>
                            <el-input v-model="form.documents[0].voided_code" type="password" dusk="voided_code" id="code_anulation"></el-input>
                            <template v-if="errors[`documents.0.voided_code`]">
                                <small class="form-control-feedback"  v-text="errors[`documents.0.voided_code`][0]"></small>
                            </template>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group" :class="{'has-danger': errors[`documents.0.description`]}">
                            <label class="control-label">Descripción del motivo de anulación</label>
                            <el-input v-model="form.documents[0].description" dusk="description" id="description_anulation"></el-input>
                            <template v-if="errors[`documents.0.description`]">
                                <small class="form-control-feedback"  v-text="errors[`documents.0.description`][0]"></small>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row form-actions mt-4">
                <div class="col-md-8">
                    <!--
                    <span v-if="hasSaleNote">
                        <label> Tiene asociado la(s) siguiente(s) nota de venta(s): </label>
                        <template v-for="(row,index) in form.sales_note">
                            <label class="d-block" :key="index">{{ row.number_full }} Fecha: {{row.date_of_issue}}</label><br>
                        </template>
                    </span>
                    -->
                </div>
                <div class="col-4 text-right">
                    <el-button @click.prevent="close()">Cancelar</el-button>
                    <el-button type="danger" native-type="submit" dusk="annulment-voided" :loading="loading_submit">
                        Anular
                    </el-button>
                </div>
            </div>
        </form>
    </el-dialog>
</template>

<script>
import {mapState, mapActions} from "vuex/dist/vuex.mjs";
export default {
    props: ['showDialog', 'recordId', 'configuration'],
    data() {
        return {
            titleDialog: null,
            loading_submit: false,
            resource: null,
            errors: {},
            form: {
                sales_note: [{}],
            },
            group_id: null,
        }
    },
    computed: {
        hasSaleNote: function () {
            if (
                this.form !== undefined &&
                this.form.sales_note !== undefined &&
                this.form.sales_note.length > 0
            ) {
                return true;
            }

            return false;
        }
    },
    created() {
        this.loadConfiguration(this.$store)
        this.$store.commit('setConfiguration', this.configuration)
        this.initForm()
    },
    methods: {
        ...mapActions(['loadConfiguration']),
        initForm() {
            this.loading_submit = false,
                this.group_id = null,
                this.errors = {},
                this.form = {
                    date_of_reference: null,
                    summary_status_type_id: '3',
                    sales_note: [{}],
                    documents: [
                        {
                            document_id: null,
                            description: null,
                        }
                    ]
                }
        },
        create() {
            this.$http.get(`/documents/record/${this.recordId}`)
                .then(response => {
                    let document = response.data.data
                    this.group_id = document.group_id
                    this.form.date_of_reference = document.date_of_issue
                    this.form.documents[0].document_id = document.id
                    this.titleDialog = 'Comprobante: ' + document.number
                    this.form.sales_note = document.sales_note;
                })
                // console.log(this.configuration.enable_anulation_password)
            if(this.configuration.enable_anulation_password){
                setTimeout(() => {
                    const el = document.getElementById('code_anulation')
                    el.focus();
                }, 200);
            }else{
                setTimeout(() => {
                    const el = document.getElementById('description_anulation')
                    el.focus();
                }, 200);
            }
        },
        submit() {
            this.loading_submit = true
            this.resource = (this.group_id === '01') ? 'voided' : 'summaries'
            this.$http.post(`/${this.resource}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$eventHub.$emit('reloadData')
                        this.$message.success(response.data.message)
                        this.close()
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        this.$message.error(error.response.data.message)
                    }
                })
                .then(() => {
                    this.loading_submit = false
                })
        },
        close() {
            this.$emit('update:showDialog', false)
            this.initForm()
        },
    }
}
</script>
